import * as React from 'react';
import {Dropdown, Flex, RadioGroup, Text} from "@fluentui/react-northstar";
import {dropdownItem} from "../newMessage";
import languageObject from "../../../translations";
import {MailingList} from "../../../Interfaces/MailingList";
import {IDraftMessage} from "../../../Interfaces/Message";

interface IChooseAudienceProps {
    draftMessage: IDraftMessage,
    selectedRadioBtn: string,
    onRadioGroupSelected: (event: any, data: any) => void,
    groupsOptionSelected: boolean,
    groupAccess: boolean,
    onGroupSearch: (itemList: any, searchQuery: string) => any,
    getGroupItems: () => dropdownItem[],
    selectedGroups: dropdownItem[],
    onGroupSearchQueryChange: (event: any, itemsData: any) => Promise<unknown>,
    onGroupsChange: (event: any, itemsData: any) => void,
    onMailingListChange: (event: any, itemsData: any) => void,
    noResultMessage: string,
    searchingGroups: boolean,
    mailingLists: Array<MailingList>,
    selectedMailingList: string,
}

class ChooseAudience extends React.PureComponent<IChooseAudienceProps> {

    render() {
        const allUsers = {
            name: "allUsers",
            key: "allUsers",
            value: "allUsers",
            label: languageObject.translate("SendToAllUsers"),
            // @ts-ignore
            children: (Component, {name, ...props}) => {
                return (
                    <Flex key={name} column style={{marginBottom: "10px"}}>
                        <Component {...props} />
                        {this.props.selectedRadioBtn !== "allUsers" ? null :
                            <div className="noteText">
                                <Text error content={languageObject.translate("SendToAllUsersNote")}/>
                            </div>
                        }
                    </Flex>
                )
            },
        };

        const groups = {
            name: "groups",
            key: "groups",
            value: "groups",
            disabled: true,
            label: (<>{languageObject.translate("SendToGroups")} <Text success
                                                                       content={languageObject.translate("DisabledCommingSoon")}
                                                                       style={{paddingLeft: 5}}/></>),
            // @ts-ignore
            children: (Component, {name, ...props}) => {
                return (
                    <Flex key={name} column style={{marginBottom: "10px"}} gap={"gap.small"}>
                        <Component {...props} />
                        {!(this.props.groupsOptionSelected && !this.props.groupAccess) ? null :
                            <div className="noteText">
                                <Text error content={languageObject.translate("SendToGroupsPermissionNote")}/>
                            </div>
                        }
                        <Dropdown
                            fluid
                            inverted
                            clearable
                            hidden={!(this.props.groupsOptionSelected && !this.props.groupAccess)}
                            placeholder={languageObject.translate("SendToGroupsPlaceHolder")}
                            search={this.props.onGroupSearch}
                            loading={this.props.searchingGroups}
                            loadingMessage={languageObject.translate("LoadingText")}
                            items={this.props.getGroupItems()}
                            value={this.props.selectedGroups}
                            onSearchQueryChange={this.props.onGroupSearchQueryChange}
                            onChange={this.props.onGroupsChange}
                            noResultsMessage={this.props.noResultMessage}
                            position={"below"}
                            align={"bottom"}
                            defaultSearchQuery={this.props.selectedGroups[0]?.header}
                        />
                        {!(this.props.groupsOptionSelected && !this.props.groupAccess) ? null :
                            <div className="noteText">
                                <Text error content={languageObject.translate("SendToGroupsNote")}/>
                            </div>
                        }
                    </Flex>
                )
            },
        };

        const mailingListsItems = this.props.mailingLists.map(i => ({key: i.id, header: i.name}));
        const selectedMailingListItem = !this.props.selectedMailingList ?
            undefined : mailingListsItems.find(i => i.key === this.props.selectedMailingList);

        const mailingLists = {
            name: "mailing-lists",
            key: "mailing-lists",
            value: "mailing-lists",
            label: languageObject.translate("SendToMailingList"),
            // @ts-ignore
            children: (Component: any, {name, ...props}) => {
                return (
                    <Flex key={name} column style={{marginBottom: "10px"}} gap={"gap.small"}>
                        <Component {...props} />
                        <Dropdown
                            fluid
                            inverted
                            clearable
                            hidden={this.props.selectedRadioBtn !== "mailing-lists"}
                            placeholder={languageObject.translate("SelectMailingList")}
                            search
                            defaultSearchQuery={selectedMailingListItem?.header}
                            items={mailingListsItems}
                            value={selectedMailingListItem}
                            onChange={this.props.onMailingListChange}
                            noResultsMessage={this.props.noResultMessage}
                            position={"below"}
                            align={"bottom"}
                        />
                    </Flex>
                )
            },
        };

        return (
            <Flex column className="form_layout" vAlign="stretch" gap="gap.small">
                <Flex column className="scrollableContent" gap="gap.small">
                    <h3>{languageObject.translate("SendHeadingText")}</h3>
                    <RadioGroup
                        className="radioBtns"
                        checkedValue={this.props.selectedRadioBtn}
                        onCheckedValueChange={this.props.onRadioGroupSelected}
                        vertical={true}
                        items={[allUsers, groups, mailingLists] as any}
                    />
                </Flex>
            </Flex>
        );
    }
}

export default ChooseAudience